<template>
  <div>
    <app-header>
      <template #title>
        <h1 class="d-inline me-4">Lead</h1>
        <span v-if="loaded" class="status" :class="stageClass(lead.stage)">{{ stageName(lead.stage) }}</span>
      </template>
    </app-header>

    <ul id="horizontal-nav" class="nav nav-horizontal">
      <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'leads.overview' }"
      >
        <a class="nav-link">Overview</a>
      </router-link>
    </ul>

    <router-view v-if="loaded"></router-view>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { stageName, stageClass } from './stages'

export default {
  data () {
    return {
      loaded: false
    }
  },

  computed: {
    ...mapState('lead', {
      lead: 'single'
    })
  },

  mounted () {
    this.loadData()
  },

  methods: {
    ...mapActions('lead', { getLead: 'getSingle' }),

    stageName,
    stageClass,

    loadData () {
      this.getLead(this.$route.params.lead_id).then(() => {
        this.loaded = true
      })
    }
  }
}
</script>
